export const getPersonWord = (number: number, locale?: string): string => {
  if (locale === 'en' && number === 1) {
    return 'guest';
  }
  if (locale === 'en') {
    return 'guests';
  }

  if (number === 1) return 'гостя';
  if (number % 10 === 1 && number % 100 !== 11) {
    return 'гость';
  } else if (
    [2, 3, 4].includes(number % 10) &&
    ![12, 13, 14].includes(number % 100)
  ) {
    return 'гостей';
  } else {
    return 'гостей';
  }
};
